// mds-dojo — dijit/_Calendar — FAITHFUL port of references/dijit/_Calendar.js.
// Deprecated alias: dijit._Calendar had an underscore only because it did not satisfy
// dijit's a11y policy; it now simply IS dijit/Calendar.
//
// ADAPTATIONS: `dojo/_base/declare` chain n/a; `kernel.deprecated` guarded (the slim mds
// kernel lacks it). The AMD original returned nothing (pure side-effect: dijit._Calendar =
// Calendar); here we also `export default Calendar` so ESM consumers get the widget.
import kernel from '../dojo/_base/kernel'; // kernel.deprecated
import Calendar from './Calendar';
import dijit from './main';	// for exporting dijit.Calendar

(kernel as any).deprecated && (kernel as any).deprecated("dijit._Calendar is deprecated", "dijit._Calendar moved to dijit.Calendar", 2.0);

// dijit._Calendar had an underscore all this time merely because it did
// not satisfy dijit's a11y policy.
dijit._Calendar = Calendar;

export default Calendar;
